/**
 * AccessBadgePanel — Access Badges panel.
 *
 * Thin wrapper around ItemSection with the access badge image and 4-column grid.
 */
import { useDesktopStore } from '../../stores/desktop'
import { ACCESS_BADGE_ICON } from '../../assets'
import ItemSection from './ItemSection'

export default function AccessBadgePanel() {
  const { accessBadges, setAccessBadges } = useDesktopStore()
  return (
    <ItemSection
      items={accessBadges}
      setItems={setAccessBadges}
      title="Access Badges"
      image={ACCESS_BADGE_ICON}
      itemLabel="Badge"
      cols={4}
      cardVariant="spare"
    />
  )
}
